import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getAuthoringLegislation = api(async function getAuthoringLegislation({ id }) {
    return query(
        gql`
            query GetAuthoringLegislation($id: String!) {
                getAuthoringLegislation(id: $id) {
                    id
                    legacyId
                    redirectId
                    title
                    redirectUrl
                    url
                    description
                    scheduleCount
                    customScheduleCount
                    lastModified
                    schedules {
                        id
                        title
                        code
                        version
                    }
                }
            }
        `,
        { id },
        { returns: "getAuthoringLegislation" }
    )
})
